
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("iCTDK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ForgeRunnerReactFragment", () => $8fd1e88d1c30ce9d$export$743f82507a5d7ce8);
$parcel$export(module.exports, "WithWrapper", () => $8fd1e88d1c30ce9d$export$d490be43e8abbd47);
$parcel$export(module.exports, "ForgeRunnerModuleDumb", () => $8fd1e88d1c30ce9d$export$675e01ecb93d0a74);
$parcel$export(module.exports, "ForgeRunnerModule", () => $8fd1e88d1c30ce9d$export$c75218f48f4de8c0);
$parcel$export(module.exports, "default", () => $8fd1e88d1c30ce9d$export$2e2bcd8739ae039);
/* forge-runner.tsx generated by @compiled/babel-plugin v3.0.2 */ // Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @compiled/jsx-pragma

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $i7phc = parcelRequire("i7phc");

var $fKuli = parcelRequire("fKuli");

var $7UzY5 = parcelRequire("7UzY5");

var $5TkOb = parcelRequire("5TkOb");

var $cKOyj = parcelRequire("cKOyj");
parcelRequire("4AKYU");
var $inpZw = parcelRequire("inpZw");

var $a34pD = parcelRequire("a34pD");
parcelRequire("6ur3J");
var $hbOvi = parcelRequire("hbOvi");

var $7WQx2 = parcelRequire("7WQx2");

var $k4dp8 = parcelRequire("k4dp8");
const $8fd1e88d1c30ce9d$export$743f82507a5d7ce8 = ({ extension: extension, type: type, page: page, portalId: portalId, requestKey: requestKey, requestTypeId: requestTypeId, noWrapper: noWrapper })=>{
    const pages = extension.properties.pages || [];
    const isCSMTypographyMigrationEnabled = (0, $k4dp8.useIsCSMTypographyMigrationEnabled)();
    // BEARS-3054: CSM renders only extensions explicitly declaring csm_help_center; other pages keep the all-pages fallback.
    const isEligible = page === (0, $i7phc.FORGE_CSM_HELP_CENTER) ? pages.includes((0, $i7phc.FORGE_CSM_HELP_CENTER)) : pages.includes(page) || pages.length === 0;
    const extensionData = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        const computedExtensionData = {
            page: page,
            type: type
        };
        if (!!portalId) computedExtensionData.portal = {
            id: portalId
        };
        if (requestKey || requestTypeId) computedExtensionData.request = {
            ...requestKey && {
                key: requestKey
            },
            ...requestTypeId && {
                typeId: requestTypeId
            }
        };
        return computedExtensionData;
    }, [
        page,
        portalId,
        requestKey,
        requestTypeId,
        type
    ]);
    return isEligible ? // to-do: reconcile with jira customer-service-support-website-edit SharedForgeRunner into one shared runner. See BEARS-3008.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        key: extension.id
    }, isCSMTypographyMigrationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            "_19pk1ejb _otyru2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "xsmall"
    }, extension.properties.title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hbOvi.Headline), null, extension.properties.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7UzY5.ExtensionProvider), {
        extension: extension,
        noWrapper: noWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5TkOb.Renderer), {
        extension: extension,
        extensionData: extensionData
    }))) : null;
};
const $8fd1e88d1c30ce9d$export$d490be43e8abbd47 = ({ page: page, children: children, noWrapper: noWrapper, skipHelpCenterWrapper: skipHelpCenterWrapper })=>{
    if (skipHelpCenterWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children);
    if (page === (0, $i7phc.FORGE_HELP_CENTER)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $a34pD.StyledForgeContainer), {
        noWrapper: !!noWrapper
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children);
};
const $8fd1e88d1c30ce9d$export$675e01ecb93d0a74 = ({ page: page, portalId: portalId, projectId: projectId, requestKey: requestKey, requestTypeId: requestTypeId, type: type, extensions: extensions, showBanner: showBanner, resetBannerState: resetBannerState, noWrapper: noWrapper, skipHelpCenterWrapper: skipHelpCenterWrapper })=>{
    const allowedExtensions = (0, $cKOyj.default)(extensions, page, true, showBanner, resetBannerState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, allowedExtensions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fKuli.ExtensionPointProvider), {
        extensionType: type,
        noWrapper: noWrapper
    }, allowedExtensions.map((extension)=>extension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8fd1e88d1c30ce9d$export$d490be43e8abbd47, {
            page: page,
            key: `${extension.id}-wrapper`,
            noWrapper: !!noWrapper,
            skipHelpCenterWrapper: skipHelpCenterWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8fd1e88d1c30ce9d$export$743f82507a5d7ce8, {
            key: extension.id,
            type: type,
            page: page,
            portalId: portalId,
            projectId: projectId,
            requestKey: requestKey,
            requestTypeId: requestTypeId,
            extension: extension,
            noWrapper: noWrapper
        })))));
};
const $8fd1e88d1c30ce9d$export$c75218f48f4de8c0 = (0, $inpZw.withExtensionList)()($8fd1e88d1c30ce9d$export$675e01ecb93d0a74);
var $8fd1e88d1c30ce9d$export$2e2bcd8739ae039 = $8fd1e88d1c30ce9d$export$c75218f48f4de8c0;
const $8fd1e88d1c30ce9d$var$headingContainerCSS = null;

});
parcelRegister("7UzY5", function(module, exports) {
$parcel$export(module.exports, "ExtensionProvider", () => $17cc64775115709b$export$c6ef18cd2d1a61a0);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $17cc64775115709b$export$c6ef18cd2d1a61a0 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("1OlFr")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/extension-provider/extension-provider.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("1OlFr", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kX0aw").then(()=>parcelRequire('6FYkG'));

});


parcelRegister("cKOyj", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f69e3df21a62c7d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gYq50 = parcelRequire("gYq50");
const $6f69e3df21a62c7d$var$useShowBannerHook = (// TODO: Fix the issue with the extensions being undefined https://hello.jira.atlassian.cloud/browse/PORTAL-5931
extensions = [], page, shouldCallBanner, showBanner, resetBannerState)=>{
    const wasShowBannerCalled = (0, $bSJIT.useRef)(false);
    const allowedExtensions = (0, $bSJIT.useMemo)(()=>{
        if (!(extensions !== null && extensions !== void 0 && extensions.length)) return [];
        return extensions.filter((extension)=>{
            var _extension$dataClassi;
            return (extension === null || extension === void 0 || (_extension$dataClassi = extension.dataClassificationPolicyDecision) === null || _extension$dataClassi === void 0 ? void 0 : _extension$dataClassi.status) !== (0, $gYq50.BLOCKED);
        });
    }, [
        extensions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (shouldCallBanner && (allowedExtensions === null || allowedExtensions === void 0 ? void 0 : allowedExtensions.length) !== (extensions === null || extensions === void 0 ? void 0 : extensions.length) && showBanner) {
            showBanner(page);
            wasShowBannerCalled.current = true;
        }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowedExtensions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if (wasShowBannerCalled.current && resetBannerState) resetBannerState(page);
        };
    // Not adding all deps here since we only want to run this cleanup upon unmount and also when allowedExtensions change
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowedExtensions
    ]);
    return allowedExtensions;
};
var $6f69e3df21a62c7d$export$2e2bcd8739ae039 = $6f69e3df21a62c7d$var$useShowBannerHook;

});

parcelRegister("4AKYU", function(module, exports) {
$parcel$export(module.exports, "withExtensionList", () => (parcelRequire("inpZw")).withExtensionList);

var $inpZw = parcelRequire("inpZw");

});
parcelRegister("inpZw", function(module, exports) {
$parcel$export(module.exports, "withExtensionList", () => $8986731486865644$export$15485afd16a49f87);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $i7phc = parcelRequire("i7phc");

var $9WNwm = parcelRequire("9WNwm");

var $jKkFd = parcelRequire("jKkFd");
const $8986731486865644$var$TrustedFetchExtensionComponent = ({ extensionType: extensionType, page: page, children: children, resourceId: resourceId, resourceType: resourceType, showBanner: showBanner, resetBannerState: resetBannerState })=>{
    const resourceContext = (0, $bSJIT.useMemo)(()=>({
            resourceId: resourceId,
            resourceType: resourceType
        }), [
        resourceId,
        resourceType
    ]);
    const { extensions: extensions } = (0, $jKkFd.useTFExtensionList)({
        resourceContext: resourceContext,
        page: page,
        type: extensionType
    });
    const childrenWithProps = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(children, {
        extensions: extensions,
        showBanner: showBanner,
        resetBannerState: resetBannerState
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, childrenWithProps);
};
const $8986731486865644$var$TrustedFetchComponentsWithBannerProps = (0, $egQxE.connect)(null, (0, $9WNwm.mapDispatchToPropsBanner))($8986731486865644$var$TrustedFetchExtensionComponent);
const $8986731486865644$export$15485afd16a49f87 = (type)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const extensionType = type || (props === null || props === void 0 ? void 0 : props.type);
            if (!extensionType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, {
                ...props,
                extensions: []
            });
            const { requestKey: requestKey, projectId: projectId, page: page } = props;
            let resourceType = (0, $i7phc.RESOURCE_TYPE_UNKNOWN);
            let resourceId;
            if (requestKey) {
                resourceType = (0, $i7phc.RESOURCE_TYPE_ISSUE);
                resourceId = requestKey;
            } else if (projectId) {
                resourceType = (0, $i7phc.RESOURCE_TYPE_PROJECT);
                resourceId = projectId.toString();
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8986731486865644$var$TrustedFetchComponentsWithBannerProps, {
                extensionType: extensionType,
                resourceId: resourceId,
                resourceType: resourceType,
                page: page
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
        };

});


parcelRegister("6ur3J", function(module, exports) {
$parcel$export(module.exports, "RequestDetailsMainSectionModule", () => $83e3493660ffcd98$export$dfdf727a544e3310);
$parcel$export(module.exports, "Headline", () => (parcelRequire("hbOvi")).Headline);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

var $hbOvi = parcelRequire("hbOvi");

const $83e3493660ffcd98$export$dfdf727a544e3310 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>Promise.resolve((parcelRequire("hbOvi"))), {
        moduleId: "./src/view/forge-ui/request-details-main-section/request-details-main-section.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("hbOvi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "RequestDetailsMainSectionModuleDumb", () => $6c9bca352110bfe4$export$6210a00c7d757443);
$parcel$export(module.exports, "Headline", () => $6c9bca352110bfe4$export$e1faab0803786bcf);
$parcel$export(module.exports, "RequestDetailsMainSectionModule", () => $6c9bca352110bfe4$export$dfdf727a544e3310);
$parcel$export(module.exports, "default", () => $6c9bca352110bfe4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $i7phc = parcelRequire("i7phc");

var $fKuli = parcelRequire("fKuli");

var $7UzY5 = parcelRequire("7UzY5");

var $5TkOb = parcelRequire("5TkOb");

var $98sDU = parcelRequire("98sDU");

var $hWJRY = parcelRequire("hWJRY");

var $cKOyj = parcelRequire("cKOyj");
parcelRequire("4AKYU");
var $inpZw = parcelRequire("inpZw");
const $6c9bca352110bfe4$export$6210a00c7d757443 = ({ extensions: extensions, portalId: portalId, requestKey: requestKey, requestTypeId: requestTypeId, showBanner: showBanner, resetBannerState: resetBannerState })=>{
    const [extensionMap, setExtensionMap] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState({});
    const [isAllPromisedSettled, setIsAllPromiseSettled] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const allowedExtensions = (0, $cKOyj.default)(extensions, (0, $i7phc.FORGE_REQUEST_DETAILS), true, showBanner, resetBannerState);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!allowedExtensions.length) return;
        const promises = allowedExtensions.map((extension)=>{
            const tokens = extension.id.split('/');
            return (0, $hWJRY.getRequestCreateProperty)({
                requestKey: requestKey,
                propertyKey: tokens[1],
                extensionId: extension.id
            });
        });
        const allSettledPromises = (promisesArg)=>Promise.all(promisesArg.map((promise)=>promise.then((value)=>({
                        value: value,
                        status: 'fulfilled'
                    })).catch((reason)=>({
                        reason: // Suppressing existing violation. Please fix this.
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        reason,
                        value: {
                            extensionId: undefined,
                            key: undefined,
                            value: undefined
                        },
                        status: 'rejected'
                    }))));
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        allSettledPromises(promises).then((respArray)=>{
            const tempExtensionMap = {};
            for (const extMap of respArray)if (extMap.status === 'fulfilled' && extMap.value !== undefined) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            tempExtensionMap[extMap.value.extensionId ?? ''] = {
                key: extMap.value.key,
                value: extMap.value.value
            };
            setExtensionMap(tempExtensionMap);
            setIsAllPromiseSettled(true);
        });
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        extensions,
        requestKey
    ]);
    const getRequestDetailsMainExtensionData = (extensionId)=>{
        return {
            type: (0, $i7phc.REQUEST_DETAIL_MAIN_SECTION_MODULE),
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId,
                key: requestKey,
                properties: extensionMap[extensionId]
            }
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, allowedExtensions.length > 0 && isAllPromisedSettled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6c9bca352110bfe4$export$e1faab0803786bcf, null, "Apps"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fKuli.ExtensionPointProvider), {
        extensionType: (0, $i7phc.REQUEST_DETAIL_MAIN_SECTION_MODULE)
    }, allowedExtensions.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
            key: extension.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6c9bca352110bfe4$export$e1faab0803786bcf, null, extension.properties.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7UzY5.ExtensionProvider), {
            extension: extension
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5TkOb.Renderer), {
            extension: extension,
            extensionData: getRequestDetailsMainExtensionData(extension.id)
        })))))));
};
const $6c9bca352110bfe4$export$dfdf727a544e3310 = (0, $inpZw.withExtensionList)((0, $i7phc.REQUEST_DETAIL_MAIN_SECTION_MODULE))($6c9bca352110bfe4$export$6210a00c7d757443);
var $6c9bca352110bfe4$export$2e2bcd8739ae039 = $6c9bca352110bfe4$export$dfdf727a544e3310;
const $6c9bca352110bfe4$export$e1faab0803786bcf = /*#__PURE__*/ (0, $4v2A7.default).h3.withConfig({
    componentId: "sc-1lbuk53-0"
})`${$98sDU.h400};margin-top:${"var(--ds-space-300, 24px)"};margin-bottom:${"var(--ds-space-100, 8px)"};`;

});
parcelRegister("hWJRY", function(module, exports) {
$parcel$export(module.exports, "getRequestCreateProperty", () => $1e5edc61c9b800c5$export$4508deacf0a161d9);

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $1e5edc61c9b800c5$export$4508deacf0a161d9 = ({ requestKey: requestKey, propertyKey: propertyKey, extensionId: extensionId, context: context = (0, $eDcdn.contextPath) })=>{
    const uri = `${context}/rest/api/3/issue/${requestKey}/properties/${propertyKey}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri).toPromise().then((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return {
            extensionId: extensionId,
            ...ajaxResponse.response
        };
    }).catch((e)=>Promise.reject(e));
};

});





//# sourceMappingURL=forge-runner.2e5faf1d.js.map
